import { Form,Table,Card} from '@deere/ux.uxframe-react'
import {IconButton} from "@deere/fuel-react"
import { React } from 'react'
import { useTranslation } from "react-i18next";
import { SVGIconDelete } from '../SVGIcon';
import { getRequestStatusWhenCampaignClosed } from '../../utils/utils';

export default function SuppliersCMRTCard({ loading, index, assignmentId, handleRemoveFn, suppliersInGroup,canRemove, campaign }) {
    const { t } = useTranslation();

    return (
        <Card>
            <Card.Body>
                <Card.Title className='pb-3 font-weight-bold'>
                    {index} {t('cm_lbl_suppliers_title')}
                </Card.Title>
                <Form.Row className="d-block mb-4">
                    {suppliersInGroup && suppliersInGroup.length > 0?
                    <Table  responsive size="sm">  
                        <tbody>
                            {
                                suppliersInGroup.map((supplierInGroup, index) =>
                                    <tr id={index} key={index}>
                                        <td className="text-left">
                                            {supplierInGroup.supplierNumber} - {supplierInGroup.supplierName} (Request {supplierInGroup.id} Status: {supplierInGroup && campaign ? getRequestStatusWhenCampaignClosed(supplierInGroup.status, campaign.status) : ""})
                                        </td>
                                        <td className="text-center">
                                            {(supplierInGroup.id !== assignmentId && canRemove) && <div style={{ textAlign: "left" }}>
                                                <IconButton disabled={loading} aria-label="delete" onClick={e => handleRemoveFn(supplierInGroup)}>
                                                    <SVGIconDelete />
                                                </IconButton>
                                            </div>}
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                        </Table>:<></>
                    }
                </Form.Row>
            </Card.Body>
        </Card>);
}
